import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import  NavComp  from './Components/mainComp/NavComp';
import FooterComp from './Components/mainComp/FooterComp';
import Body from './Components/BodyComp/body';
import ContactUs from './Components/ContactComp/contactus';
import AboutUs from './Components/AboutComp/aboutus';
import WhatsAppButton from './Components/Whatsapp/WhatsAppButton';
import ScrollToTop from './ScrollComp/ScrollToTop';
import LowerExtremityProsthetics from './Components/ProductComp/lower-extremity-prosthetics';
import RehaMobility from './Components/ProductComp/reha-mobility';
import OrthopedicsChildren from './Components/ProductComp/orthopedics-children';
import UpperExtremityProsthetics from './Components/ProductComp/upper-extremity-prosthetics';
import SpinalOrthotics from './Components/ProductComp/spinal-orthotics';
import PhysiotherapyForRehabilitation from './Components/PhysiotherapyComp/physiotherapy-for-rehabilitation';




function App() {
  return (
 <Router>
  <ScrollToTop />
      <NavComp />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />}  />

        <Route path="/lower-extremity-prosthetics" element={<LowerExtremityProsthetics />} />
        <Route path="/reha-mobility" element={<RehaMobility />} />
        <Route path="/orthopedics-children" element={<OrthopedicsChildren />} />
        <Route path="/upper-extremity-prosthetics" element={<UpperExtremityProsthetics />}  />
        <Route path="/spinal-orthotics" element={<SpinalOrthotics />}  />
        <Route path="/physiotherapy-for-rehabilitation" element={<PhysiotherapyForRehabilitation />}  />




      </Routes>
    
      <FooterComp /> 
      <WhatsAppButton />
    </Router>
  );
}

export default App;
